'use client';

import Script from 'next/script';

import { useDecisions } from '../../hooks';
import { getENV } from '../../utils/env';

export const OneTrustHeadScriptV2 = () => {
    const isOneTrust = useDecisions('onetrust');

    if (!isOneTrust) return null;

    const {
        NEXT_PUBLIC_ONETRUST_SCRIPT_US_URL,
        NEXT_PUBLIC_ONETRUST_SCRIPT_CA_URL,
        NEXT_PUBLIC_ONETRUST_US_DOMAIN_SCRIPT_ID,
        NEXT_PUBLIC_ONETRUST_CA_DOMAIN_SCRIPT_ID,
        NEXT_PUBLIC_LOCALE,
    } = getENV();

    const isCA = NEXT_PUBLIC_LOCALE === 'en-CA';
    const src = isCA ? NEXT_PUBLIC_ONETRUST_SCRIPT_CA_URL : NEXT_PUBLIC_ONETRUST_SCRIPT_US_URL;
    const scriptId = isCA ? NEXT_PUBLIC_ONETRUST_CA_DOMAIN_SCRIPT_ID : NEXT_PUBLIC_ONETRUST_US_DOMAIN_SCRIPT_ID;

    return <Script id="OneTrust-Script" strategy="beforeInteractive" src={src} data-domain-script={scriptId} />;
};
